<template>
  <div></div>
</template>
<script>
  import { ContractService } from '../../services/contract.service'
  export default {
    async created() {
      try {
        const param = this.$route.query
        if (!param || !param.accessKeyS3) {
          alert('Thông tin không hợp lệ !')
        }
        /*
      let dataContractRespon = {}
      const getByCode = await this.getByCode(param.contractId)
      if (getByCode.code === 1000) {
        dataContractRespon = await ContractService.getLinkPDF({
          contractId: param.contractId
        })
      } else {
        dataContractRespon = await ContractService.getLinkPDF_s3_v2({
          contractId: param.contractId
        })
      }
      */

        const body = {
          contractId: param.contractId && param.contractId !== null ? param.contractId : '',
          appendixId: param.appendixId && param.appendixId !== null ? param.appendixId : '',
          accessKeyS3: param.accessKeyS3,
        }

        const dataContractRespon = await ContractService.getLinkPDF(body)
        if (dataContractRespon.code !== 1000) {
          alert('Thông tin không hợp lệ !')
          return
        }
        let redirectUrl = dataContractRespon.data.urlContractS3
        if (!redirectUrl.includes('key=')) {
          const separator = redirectUrl.includes('?') ? '&' : '?'
          redirectUrl = `${redirectUrl}${separator}key=${param.accessKeyS3}`
        }
        window.location.href = redirectUrl
        return false
      } catch (err) {
        alert('Đã có lỗi xảy ra')
        console.log(err)
      }
    },
    methods: {
      async getByCode(id) {
        try {
          const data = await ContractService.getByCode({ code: id, groupService: 'PAYMENT' })
          alert(data)
          console.log(data)
          return data
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped></style>
